module.exports = __webpack_public_path__ + "static/media/Koch Technology Center.7094a7cb.svg";